// Статусы отправки формы для отображения соответствующего экрана
export const SUPPORT_STATUS = {
    IDLE: null,
    SUCCESS: "success",
    ERROR: "error"
};

// Правила валидации полей.
export const VALIDATION_RULES = {
    NAME_MIN_LENGTH: 1,
    EMAIL_PATTERN: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    QUESTION_MIN_LENGTH: 1
};

// Максимальный размер загружаемого файла
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 МБ в байтах